import { useRouter } from 'next/router'

export const useIsArabic = () => {
    const { locale } = useRouter()
    return locale === 'ar'
}
